export default __webpack_public_path__ + "resources/icons/n220-4b4b.png";